module.exports = __webpack_public_path__ + "img/tim.82de528e.svg";